<template>
  <div>
    <label
      class="file-label"
      :style="`width: ${getLabelWidth()}`"
      v-if="this.field.metadata.showFieldLabel"
      >{{ this.field.metadata.label }}
      <span class="required" v-if="this.field.metadata.required">*</span>
    </label>
    <div class="input-wrapper">
      <input
        type="file"
        class="file-input"
        :name="this.field.metadata.fieldName"
        :accept="getExtensions()"
        :required="this.field.metadata.required"
      />
      <div class="hint" v-if="this.field.metadata.hint">
        <span v-html="this.field.metadata.hint"></span>
      </div>
      <span class="hint" v-if="this.field.metadata.showReqHint">
        {{ this.REQ_HINT }}
      </span>
    </div>
  </div>
</template>

<script>
import { MESSAGES } from "../mixins/constant-mixin";

export default {
  name: "FormFile",
  props: {
    field: {
      type: Object,
    },
  },
  data() {
    return {
      REQ_HINT: MESSAGES.REQ_HINT
    };
  },
  methods: {
    getExtensions: function () {
      if (this.field.metadata.extensions) {
        return this.field.metadata.extensions;
      }
      return "*";
    },
    getLabelWidth: function () {
      let width = "auto";
      const labelWidth = this.field.metadata.labelWidth;
      if (labelWidth && labelWidth > 0 && labelWidth <= 12) {
        width = `calc(${parseInt(labelWidth)} * 100%/12)`;
      }
      return width;
    },
  },
};
</script>

<style scoped>
.file-label {
  display: inline-block;
}

.input-wrapper {
  padding-top: 0.5rem;
  display: inline-flex;
  flex-direction: column;
}

.file-input {
  color: #0073c3;
}

.file-input::file-selector-button {
  color: #0073c3;
  background: #fff;
  padding: 8px 16px;
  margin-right: 12px;
  border: 1px solid #0073c3;
  border-radius: 0.25rem;
}

.hint {
  color: #8a8a8a;
  margin-top: 5px;
}

.hint >>> * {
  margin-top: 0;
  margin-bottom: 0;
}

.required {
  color: #f00;
}
</style>